import { privacyPolicyHTML } from "./privacy_policy";
import { Page, Container, DocumentBody } from './styles';
import AcceptanceBar from "../../acceptance_terms_footer";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  return (
    <Page>
      <Container>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={{ width: '100%' }}
        >
          <DocumentBody dangerouslySetInnerHTML={{ __html: privacyPolicyHTML }} />
        </motion.div>
        <AcceptanceBar path={'/terms_of_use'} />
      </Container>
    </Page>
  );
};

export default PrivacyPolicy;
